import { DamsAppAsset } from "../../assets/registry";
import { ModalBase } from "./ModalBase";

export function ActionModal({
  show,
  title,
  subtitle,
  onRightBtnPress,
  rightBtnTxt,
  onLeftBtnPress,
  leftBtnTxt,
  onClosePress,
  leftIcon,
  onRightBtnLoading,
  isFullScreen=false
}: Readonly<{
  show: boolean;
  title: string;
  subtitle:  string | React.ReactElement;
  onRightBtnPress: () => void;
  rightBtnTxt: string;
  onLeftBtnPress: () => void;
  leftBtnTxt: string;
  onClosePress?: () => void;
  leftIcon?: string;
  onRightBtnLoading?: boolean;
  isFullScreen?:boolean
}>) {
  return (
    <ModalBase
      open={show}
      title={title}
      subtitle={subtitle}
      leftIcon={leftIcon}
      type="action"
      rightBtnTxt={rightBtnTxt}
      onRightBtnPress={onRightBtnPress}
      onRightBtnLoading={onRightBtnLoading}
      leftBtnTxt={leftBtnTxt}
      onLeftBtnPress={onLeftBtnPress}
      onClose={onClosePress}
      isFullScreen={isFullScreen}
    />
  );
}

export function ConfirmActionModal({
  show,
  title,
  subtitle,
  onRightBtnPress,
  rightBtnTxt,
  onLeftBtnPress,
  leftBtnTxt,
  onClosePress,
  onRightBtnLoading,
  isFullScreen=false
}: Readonly<{
  show: boolean;
  title: string;
  subtitle:  string | React.ReactElement;
  onRightBtnPress: () => void;
  rightBtnTxt: string;
  onLeftBtnPress: () => void;
  leftBtnTxt: string;
  onClosePress?: () => void;
  onRightBtnLoading?: boolean;
  isFullScreen?:boolean
}>) {
  return (
    <ModalBase
      leftIcon={DamsAppAsset.icons.warning}
      open={show}
      title={title}
      subtitle={subtitle}
      type="action"
      rightBtnTxt={rightBtnTxt}
      onRightBtnPress={onRightBtnPress}
      onRightBtnLoading={onRightBtnLoading}
      leftBtnTxt={leftBtnTxt}
      onLeftBtnPress={onLeftBtnPress}
      onClose={onClosePress}
      isFullScreen={isFullScreen}
    />
  );
}

export default ActionModal;
